import React, { useState } from "react";
import { Loader2 } from "lucide-react";

interface DropdownProps {
  onSelect: (value: number) => void;
}

const TableDropDownSmall: React.FC<DropdownProps> = ({ onSelect }) => {
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const options = [5, 10, 20, 30, 50 , 100];

  const handleSelect = async (value: number) => {
    setSelectedValue(value);
    setIsOpen(false);
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000)); // شبیه‌سازی تأخیر
    setLoading(false);
    onSelect(value);
  };

  return (
    <div className="relative inline-block text-right">
      {loading && (
        <div className="absolute  inset-0 flex items-center justify-center bg-white/70 rounded-lg">
          <Loader2 className="animate-spin text-blue-500" size={24} />
        </div>
      )}
      <div
        className={`block w-full   px-4 py-2 text-sm bg-gray-100 text-gray-700 border border-gray-300 rounded-lg shadow-sm ${
          isOpen ? "ring-2 ring-blue-500" : "focus:ring-2 focus:ring-blue-500"
        }  focus:outline-none dark:bg-gray-800  dark:text-white dark:border-gray-600 hover:bg-gray-200 transition-all duration-300 cursor-pointer`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedValue ?? "تعداد سطر"}
      </div>
      {isOpen && (
        <div className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-600" dir="rtl">
          {options.map((value, index) => (
            <div
              key={index}
              onClick={() => handleSelect(value)}
              className="px-4 py-2 text-sm text-gray-700 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-300 last:border-none"
            >
              {value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TableDropDownSmall;
